import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { HelmetProvider } from 'react-helmet-async';
render(<HelmetProvider data-id="element-430">
    <App data-id="element-431" />
  </HelmetProvider>, document.getElementById('root'));